// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    0,
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "生产运作与项目管理",
      "tec": "郭艳秋",
      "week": "1-8,11周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "新能源机械设备",
      "tec": "白斌",
      "week": "1-8周",
      "add": "教学楼A座425机械"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "生产运作与项目管理",
      "tec": "郭艳秋",
      "week": "3-5周",
      "add": "教学楼A座422机械"
    },
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "新能源机械设备",
      "tec": "白斌",
      "week": "1-8周",
      "add": "教学楼A座421机械"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
